import React from "react";
import { Navigate } from "react-router-dom";
import LoadingComponent from "../../lib/LoadingComponent";
import useRegisterPrefix from "../../lib/Register/useRegisterPrefix";
import Register from "./Register";
import RegisterPmuc from "./RegisterPmuc";

// เลือกหน้า register ตาม service ของ business (route เดียว: /:prefix/register)
function RegisterRoute() {
  const { prefix, services, ready } = useRegisterPrefix();

  if (!ready) return <LoadingComponent />;

  // service pmuc มาก่อน (ตรงกับของเดิมที่ pmuc flow ทับ flow ปกติ)
  if (services.includes("employee-pre-register-pmuc")) {
    return <RegisterPmuc prefix={prefix} />;
  }
  if (services.includes("employee-pre-register")) {
    return <Register prefix={prefix} services={services} />;
  }
  return <Navigate to={`/${prefix}`} replace />;
}

export default RegisterRoute;